import BaseQuery from "@/stateManagement/BaseQuery";
import { injectable } from "tsyringe";

import CustomerStore, { CustomerState } from "../stores/CustomerStore";

@injectable()
class CustomerQuery extends BaseQuery<CustomerState> {
    constructor(protected store: CustomerStore) {
        super(store);
    }

    storeCreditBalance$ = this.select((state) => state.storeCreditBalance);
    status$ = this.selectStatus();
}

export default CustomerQuery;
